/**
 * SnaggingPro business contact details printed on client-facing
 * documents (quotation, future receipts, etc.).
 */

export const BUSINESS = {
  name: 'SnaggingPro',
  tagline: 'Property condition assessment · UAE',
  phone: '+971 55 547 7206',
} as const;
